"use client";

import * as React from "react";

import { createSVGIcon } from "../../util";

/** @optimized using svgo:^3.0.2 */
export const Organic = createSVGIcon(
  <>
    <path
      d="M21 18.772h-2.756v-7.57H21zM18.244 12.647h-1.072c-.574 0-1.186 0-1.76.076-1.034.153-1.99.495-2.985.761-.192.038-.383.114-.575.114H9.058c-.459 0-.88.38-.88.875 0 .533.421.951.957.951h2.7560000000000002c.42 0 .918.076 1.224.38"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.135 15.424a12.2 12.2 0 0 1-3.33-.837q-.746-.285-1.492-.684c-.23-.115-.46-.229-.728-.153-.19.038-.382.152-.459.305-.268.418-.076.912.268 1.217 0 0 2.22 2.168 5.588 2.739.65.114 1.263.19 1.914.19.88 0 1.722-.152 2.602-.305.536-.114 1.072-.19 1.608-.304.497-.114.995-.304 1.53-.304h1.646"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.728 13.027s-.497-.684-1.378-1.369a3.5 3.5 0 0 0-5.013.685c-.383.532-.728 1.179-.996 2.054"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.169 10.898s-.498-6.01 3.942-6.01c0 0-.115 3.461-3.713 3.5"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.321 8.311s.421-3.537-3.176-5.211c0 0-.65 3.804 3.023 5.287"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Organic",
  { viewBox: "0 0 24 24", titleAccess: "Organic", fill: "none" }
);
